// Fun guest names for anonymous players
export const GUEST_NAMES = [
  'SnackLord',
  'LagGoblin',
  'SirSpamsAlot',
  'ButtonMasher',
  'YeetYeti',
  'OopsieDaisy',
  'GravyBoat',
  'NoodleKing',
  'SneezeWeasel',
  'WaffleBandit',
  'TurboPigeon',
  'CaptainCrumbs',
  'BonkWizard',
  'SneakyPeanut',
  'SirLaggington',
  'ToastGhost',
  'PicklePirate',
  'ZoomBroom',
  'ChonkMonk',
  'SpiceGremlin',
  'BoopMachine',
  'SlothSprint',
  'DootDoot',
  'BurritoBoss',
  'MisterMishap',
  'PanicPanda',
  'SirBloop',
  'FeralBagel',
  'HamsterHeist',
  'CheekySpoon',
  'PotatoPriest',
  'BlepMaster',
  'CrayonKnight',
  'FizzWarden',
  'Sneezington',
  'MuffinMarauder',
  'TrashPandaPro',
  'GremlinMode',
  'ShinyBeard',
  'SporkNinja',
  'PuddleKing',
  'NopeRope',
  'SirSnacc',
  'HyperGherkin',
  'WobbleGoblin',
  'NaptimeHero',
  'QuackAttack',
  'MisterPickles',
  'GiggleFang',
  'CrumbSnatcher',
  'DripNoodle',
  'TinyChaos',
  'BeefSupreme',
  'EggWhisperer',
  'GlitchWitch',
  'SirOof',
  'GoblinTax',
  'CaptainDerp',
  'SlimeTime',
  'ToastyBoi',
  'ZoomiesInc',
  'ChaosGremlin',
  'PlopSoda',
  'BananaArmor',
  'SpicyCactus',
  'SirBonks',
  'FrothMoth',
  'MilkMancer',
  'BoogerBaron',
  'SoggyWizard',
  'SneakyBiscuit',
  'OopsAllLag',
  'TunaTurner',
  'WompWomp',
  'GigaSnack',
  'LintLizard',
  'CringeNinja',
  'GhostOfToast',
  'DingleDoodle',
  'CerealKillerish',
  'Purrkour',
  'BruhMoment',
  'PopcornPaladin',
  'DonutDruid',
  'MoodyGoose',
  'SpudRanger',
  'FlopChampion',
  'SirSnort',
  'BorkBork',
  'CroutonCrew',
  'WigglySteve',
  'PanicButton',
  'ButterBandit',
  'BeanBerserker',
  'DingusPrime',
  'LilUhoh',
  'ChunkyFunk',
  'SassyGnome',
  'WobbleWarlord',
  'TheLastCrumb',
];

/**
 * Generate a random guest identity
 */
export function generateGuestIdentity() {
  const randomName = GUEST_NAMES[Math.floor(Math.random() * GUEST_NAMES.length)];
  const randomId = Math.random().toString(36).substring(2, 8);
  
  return {
    twitchUserId: `guest-${randomId}`,
    login: `guest-${randomName.toLowerCase()}`,
    displayName: `Guest-${randomName}`,
    isGuest: true,
  };
}
